import { Navigate } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { useShopper } from "../lib/shopper.js";

/** Gate for signed-in pages; bounces to /login. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, authPending } = useShopper();

  if (authPending) {
    return <p className="text-sm text-muted-foreground">Loading…</p>;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
